import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SummaryMetricsType } from '../../types'

const NoMetricGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SummaryMetricsType>(widgetId)
  const { t } = useTranslation()

  if (widgetSetting.metricNames?.length === 0 && widgetSetting.measures?.length === 0) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }
  return children
}

export default NoMetricGuard
